import { apiPost, apiGet, setAuthToken, setTenantId, unwrap } from './apiClient';
import type { ResponseDTO, AuthenticationRequest, AuthenticationResponse } from '@/types/api';

export async function adminAuthenticate(body: AuthenticationRequest) {
  const res = await apiPost<ResponseDTO<AuthenticationResponse>>(
    '/api/v1/admin/authenticate',
    body
  );
  const data = unwrap(res);
  if (data.token) {
    setAuthToken(data.token);
    // Extract tenantId from JWT payload
    try {
      const payload = JSON.parse(atob(data.token.split('.')[1]));
      if (payload.tenantId) {
        setTenantId(payload.tenantId);
      }
    } catch {
      // JWT decode failed — tenant ID won't be set
    }
  }
  return data;
}

export async function deviceAuthenticate(body: Record<string, unknown>) {
  const res = await apiPost<ResponseDTO<unknown>>(
    '/api/v1/device/authenticate',
    body
  );
  return unwrap(res);
}

export async function deviceTermsOfService(body: Record<string, unknown>) {
  const res = await apiPost<ResponseDTO<unknown>>(
    '/api/v1/device/tos',
    body
  );
  return unwrap(res);
}
